export default "__VITE_ASSET__FqfwdtBz__"